import { Statistics } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';

import StatisticsItem from './statisticsItem';

export const StatisticsWr = observer(() => {
  return (
    <Statistics
      renderStatisticsItem={(item, index, list, lastRoundValue) => (
        <StatisticsItem item={item} lastRoundValue={lastRoundValue} key={index} />
      )}
    />
  );
});
